<template>
  <v-container
    class="div-100 d-flex flex-column align-center justify-center text-center"
  >
    <v-card-subtitle class="waitingroom-title">
      <p v-if="roomState === 'done'" v-html="$t('waitingroom.closed')"></p>
      <p
        v-else-if="roomState === 'pause'"
        v-html="$t('waitingroom.pause')"
      ></p>
      <p
        v-else-if="roomState === 'upcoming' || access==false"
        v-html="$t('waitingroom.title')"
      ></p>
      <!-- <p v-else-if="access">Live</p> -->
    </v-card-subtitle>

    <AgendaTimeline :headline="$t('page.timeline.headline')" :AgendaItems="EventItem.agendaItems"/> 
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AgendaTimeline from '@/components/Agenda/AgendaTimeline'
export default { 
  components:{
    AgendaTimeline
  },
  computed: {
    ...mapGetters("notification", ["roomState", "access"]),
  },
  data: () => ({
    EventItem: {eventMetaInfo:{}},
  }),
  async created() {
    this.EventItem = await this.$store.dispatch("getEventInfo");
  },  
  watch: {
    // roomState: {
    //   handler(value) {
    //     if (value === "live") {
    //       this.$router.replace({
    //         name: "Live",            
    //       });
    //     }
    //   },
    // },
    access: {
      handler(value) {
        if (value) {
          this.$router.replace({
            name: "Live",            
          });
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  line-height: 1.35em;
}


.waitingroom-title p {
 font-size: 2.45em;
 line-height: 1.35em;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'sm-and-down')} {
.waitingroom-title p {
 font-size: 1.43em; 
}
}
</style>